import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

const WhiteCardNew = ({ children, onClick = () => {} }) => {
    return (
        <div onClick={onClick} className={styles.whiteCardNew}>
            {children}
        </div>
    );
};

WhiteCardNew.propTypes = {
    children: PropTypes.any,
    onClick: PropTypes.func
};

export default WhiteCardNew;
